import { create } from 'zustand';

interface ViewUiState {
  /** The day the day view last showed; null until the day view is first opened. */
  readonly lastDayDate: string | null;
  setLastDayDate: (date: string) => void;
}

/** Cross-view date state: the day the day view last showed, handed back on the return to it. */
export const useViewUi = create<ViewUiState>((set) => ({
  lastDayDate: null,
  setLastDayDate: (date) => set({ lastDayDate: date }),
}));
